export default "__VITE_ASSET__Dd$CnRgA__"